// extracted by mini-css-extract-plugin
export default {"price":"N8-z","priceRow":"O8-z","onSale":"P8-z","msrpLabelPrice":"Q8-z","msrpLabel":"R8-z","originalPrice":"S8-z","percentOff":"T8-z"};